import React from 'react';
import { PinInputField as ChakraPinInputField, PinInputFieldProps as ChakraPinInputFieldProps } from '@chakra-ui/react';

export function PinInputField(props: ChakraPinInputFieldProps) {
  return (
    <ChakraPinInputField
      borderColor={'gray.700'}
      color={'gray.900'}
      fontSize={'32px'}
      _placeholder={{
        fontFamily: 'Roboto mono',
        color: 'gray.500'
      }}
      {...props}
    />
  );
}
